export enum EMatomoEventCategory {
  MEASUREMENT = 'Measurement',
}
